import React from "react";


export default function Footer() {

const latestYear = new Date().getFullYear() ;

    return (
        <footer className="container pt-2 border-top">
            <div className="row text-center text-md-start">
                <div className="col-12 col-md-4 text-md-start">
                    <small>&copy; <span id="currentYear">{latestYear}</span> STG Logistics. All Rights Reserved.</small>
                </div>
                <div className="col-12 col-md-4 text-center">
                    <small className="text-center"><a href="https://www.stgusa.com/privacy-policy/" target="_blank">Privacy Policy</a></small>
                </div>
                <div className="col-12 col-md-4 text-md-end">
                    <small><a href="https://www.stgusa.com/terms-conditions/" target="_blank">Terms & Conditions</a></small>
                </div>
            </div>
        </footer>
    )
}